
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";

import { useEmailViewer } from "./email-viewer/useEmailViewer";
import EmailList from "./email-viewer/EmailList";
import SmtpTestForm from "./email-viewer/SmtpTestForm";
import TestEmailHeader from "./email-viewer/TestEmailHeader";
import TestEmailTabs from "./email-viewer/TestEmailTabs";

const TestEmailViewer = ({ email }: { email: string }) => {
  const {
    emails,
    loading,
    sendingSmtpTest,
    activeTab,
    setActiveTab,
    fetchEmails,
    clearEmails,
    sendSmtpTestEmail
  } = useEmailViewer(email);

  if (!email) {
    return (
      <Card className="mt-4">
        <CardContent>
          <CardTitle>Test Emails</CardTitle>
          <CardDescription>
            No email address provided for testing
          </CardDescription>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="mt-4">
      <TestEmailHeader 
        email={email}
        loading={loading}
        onRefresh={fetchEmails}
        onClear={clearEmails}
      />
      
      <CardContent>
        <Alert className="mb-4" variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Testing Mode Information</AlertTitle>
          <AlertDescription>
            <p className="mb-2">These are <strong>simulated emails</strong> that demonstrate how authentication emails would look.</p>
            <p>The verification links are functional demo links that will let you test the workflow, but they don't contain real Supabase auth tokens.</p>
          </AlertDescription>
        </Alert>
        
        <TestEmailTabs
          emails={emails}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
        
        {['all', 'confirm_signup', 'reset_password', 'smtp_test'].map(tabValue => (
          <EmailList 
            key={tabValue} 
            tabValue={tabValue} 
            emails={emails} 
          />
        ))}
        
        <SmtpTestForm
          email={email}
          onSubmit={sendSmtpTestEmail}
          isSending={sendingSmtpTest}
        />
      </CardContent>
    </Card>
  );
};

export default TestEmailViewer;
